// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  AddContentToContainerBatchData,
  AddContentToContainerBatchErrors,
  AddContentToContainerBatchResponses,
  AddContentToContainerData,
  AddContentToContainerErrors,
  AddContentToContainerResponses,
  AssignContainersToAreaData,
  AssignContainersToAreaErrors,
  AssignContainersToAreaResponses,
  AssignContainerToAreaData,
  AssignContainerToAreaErrors,
  AssignContainerToAreaResponses,
  ChangeContentLevelBatchData,
  ChangeContentLevelBatchErrors,
  ChangeContentLevelBatchResponses,
  ConfirmPasswordResetData,
  ConfirmPasswordResetErrors,
  ConfirmPasswordResetResponses,
  ConfirmSignUpData,
  ConfirmSignUpErrors,
  ConfirmSignUpResponses,
  CreateAreaData,
  CreateAreaErrors,
  CreateAreaResponses,
  CreateArticleData,
  CreateArticleErrors,
  CreateArticleResponses,
  CreateContactData,
  CreateContactErrors,
  CreateContactResponses,
  CreateContainerData,
  CreateContainerErrors,
  CreateContainerResponses,
  CreateContainersData,
  CreateContainersErrors,
  CreateContainersResponses,
  CreateContainerTypeData,
  CreateContainerTypeErrors,
  CreateContainerTypeResponses,
  CreateOrderData,
  CreateOrderErrors,
  CreateOrderResponses,
  DeleteContainerTypeData,
  DeleteContainerTypeErrors,
  DeleteContainerTypeResponses,
  DeleteContentBatchWithoutCheckData,
  DeleteContentBatchWithoutCheckErrors,
  DeleteContentBatchWithoutCheckResponses,
  DeleteExternalSystemSettingsData,
  DeleteExternalSystemSettingsErrors,
  DeleteExternalSystemSettingsResponses,
  GetAreaByIdData,
  GetAreaByIdErrors,
  GetAreaByIdResponses,
  GetAreasData,
  GetAreasErrors,
  GetAreasResponses,
  GetContactByIdData,
  GetContactByIdErrors,
  GetContactByIdResponses,
  GetContactsData,
  GetContactsErrors,
  GetContactsResponses,
  GetContainerByIdData,
  GetContainerByIdErrors,
  GetContainerByIdResponses,
  GetContainersData,
  GetContainersErrors,
  GetContainersResponses,
  GetContainerStatisticsData,
  GetContainerStatisticsErrors,
  GetContainerStatisticsResponses,
  GetContainerTypeData,
  GetContainerTypeErrors,
  GetContainerTypeResponses,
  GetContainerTypesData,
  GetContainerTypesErrors,
  GetContainerTypesResponses,
  GetContentLevelEventStatisticsData,
  GetContentLevelEventStatisticsErrors,
  GetContentLevelEventStatisticsResponses,
  GetCuttingLengthsData,
  GetCuttingLengthsErrors,
  GetCuttingLengthsResponses,
  GetDeliveryScheduleData,
  GetDeliveryScheduleErrors,
  GetDeliveryScheduleResponses,
  GetHumidityLevelsData,
  GetHumidityLevelsErrors,
  GetHumidityLevelsResponses,
  GetMeData,
  GetMeErrors,
  GetMeResponses,
  GetOrderData,
  GetOrderErrors,
  GetOrderResponses,
  GetOrdersData,
  GetOrdersErrors,
  GetOrdersResponses,
  GetPriceOverridesData,
  GetPriceOverridesErrors,
  GetPriceOverridesResponses,
  GetPricesData,
  GetPricesErrors,
  GetPriceSettingsData,
  GetPriceSettingsErrors,
  GetPriceSettingsResponses,
  GetPricesResponses,
  GetVersionData,
  GetVersionErrors,
  GetVersionResponses,
  GetWoodTypesData,
  GetWoodTypesErrors,
  GetWoodTypesResponses,
  HealthData,
  HealthErrors,
  HealthResponses,
  InfoData,
  InfoErrors,
  InfoResponses,
  LinksData,
  LinksErrors,
  LinksResponses,
  ListArticlesData,
  ListArticlesErrors,
  ListArticlesResponses,
  ListExternalSystemsSettingsData,
  ListExternalSystemsSettingsErrors,
  ListExternalSystemsSettingsResponses,
  ScheduleDeliveryData,
  ScheduleDeliveryErrors,
  ScheduleDeliveryResponses,
  SendConfirmationMailData,
  SendConfirmationMailErrors,
  SendConfirmationMailResponses,
  SetPriceOverridesData,
  SetPriceOverridesErrors,
  SetPriceOverridesResponses,
  SetPriceSettingsData,
  SetPriceSettingsErrors,
  SetPriceSettingsResponses,
  SignInData,
  SignInErrors,
  SignInResponses,
  SignOutData,
  SignOutErrors,
  SignOutResponses,
  SignUpData,
  SignUpErrors,
  SignUpResponses,
  StartPasswordResetData,
  StartPasswordResetErrors,
  StartPasswordResetResponses,
  StoreExternalSystemSettingsData,
  StoreExternalSystemSettingsErrors,
  StoreExternalSystemSettingsResponses,
  TriggerSyncData,
  TriggerSyncErrors,
  TriggerSyncResponses,
  UnscheduleDeliveryData,
  UnscheduleDeliveryErrors,
  UnscheduleDeliveryResponses,
  UpdateAreaData,
  UpdateAreaErrors,
  UpdateAreaResponses,
  UpdateContactByIdData,
  UpdateContactByIdErrors,
  UpdateContactByIdResponses,
  UpdateContainerData,
  UpdateContainerErrors,
  UpdateContainerResponses,
  UpdateContainerTypeData,
  UpdateContainerTypeErrors,
  UpdateContainerTypeResponses,
  UpdateExternalSystemSettingsData,
  UpdateExternalSystemSettingsErrors,
  UpdateExternalSystemSettingsResponses,
  UpdateOrderData,
  UpdateOrderErrors,
  UpdateOrderResponses,
} from "./types.gen";

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Actuator root web endpoint
 */
export const links = <ThrowOnError extends boolean = false>(options?: Options<LinksData, ThrowOnError>) =>
  (options?.client ?? client).get<LinksResponses, LinksErrors, ThrowOnError>({ url: "/actuator", ...options });

/**
 * Actuator web endpoint 'health'
 */
export const health = <ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>) =>
  (options?.client ?? client).get<HealthResponses, HealthErrors, ThrowOnError>({ url: "/actuator/health", ...options });

/**
 * Actuator web endpoint 'info'
 */
export const info = <ThrowOnError extends boolean = false>(options?: Options<InfoData, ThrowOnError>) =>
  (options?.client ?? client).get<InfoResponses, InfoErrors, ThrowOnError>({ url: "/actuator/info", ...options });

export const getAreas = <ThrowOnError extends boolean = false>(options?: Options<GetAreasData, ThrowOnError>) =>
  (options?.client ?? client).get<GetAreasResponses, GetAreasErrors, ThrowOnError>({ url: "/api/areas", ...options });

export const createArea = <ThrowOnError extends boolean = false>(options: Options<CreateAreaData, ThrowOnError>) =>
  (options.client ?? client).post<CreateAreaResponses, CreateAreaErrors, ThrowOnError>({
    url: "/api/areas",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getAreaById = <ThrowOnError extends boolean = false>(options: Options<GetAreaByIdData, ThrowOnError>) =>
  (options.client ?? client).get<GetAreaByIdResponses, GetAreaByIdErrors, ThrowOnError>({
    url: "/api/areas/{areaId}",
    ...options,
  });

export const updateArea = <ThrowOnError extends boolean = false>(options: Options<UpdateAreaData, ThrowOnError>) =>
  (options.client ?? client).put<UpdateAreaResponses, UpdateAreaErrors, ThrowOnError>({
    url: "/api/areas/{areaId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const assignContainerToArea = <ThrowOnError extends boolean = false>(
  options: Options<AssignContainerToAreaData, ThrowOnError>,
) =>
  (options.client ?? client).post<AssignContainerToAreaResponses, AssignContainerToAreaErrors, ThrowOnError>({
    url: "/api/areas/{areaId}/container/{containerId}",
    ...options,
  });

export const assignContainersToArea = <ThrowOnError extends boolean = false>(
  options: Options<AssignContainersToAreaData, ThrowOnError>,
) =>
  (options.client ?? client).post<AssignContainersToAreaResponses, AssignContainersToAreaErrors, ThrowOnError>({
    url: "/api/areas/{areaId}/containers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const listArticles = <ThrowOnError extends boolean = false>(options?: Options<ListArticlesData, ThrowOnError>) =>
  (options?.client ?? client).get<ListArticlesResponses, ListArticlesErrors, ThrowOnError>({
    url: "/api/articles",
    ...options,
  });

export const createArticle = <ThrowOnError extends boolean = false>(
  options: Options<CreateArticleData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateArticleResponses, CreateArticleErrors, ThrowOnError>({
    url: "/api/articles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getContacts = <ThrowOnError extends boolean = false>(options?: Options<GetContactsData, ThrowOnError>) =>
  (options?.client ?? client).get<GetContactsResponses, GetContactsErrors, ThrowOnError>({
    url: "/api/contacts",
    ...options,
  });

export const createContact = <ThrowOnError extends boolean = false>(
  options: Options<CreateContactData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateContactResponses, CreateContactErrors, ThrowOnError>({
    url: "/api/contacts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getContactById = <ThrowOnError extends boolean = false>(
  options: Options<GetContactByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetContactByIdResponses, GetContactByIdErrors, ThrowOnError>({
    url: "/api/contacts/{contactId}",
    ...options,
  });

export const updateContactById = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContactByIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateContactByIdResponses, UpdateContactByIdErrors, ThrowOnError>({
    url: "/api/contacts/{contactId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getContainerTypes = <ThrowOnError extends boolean = false>(
  options?: Options<GetContainerTypesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetContainerTypesResponses, GetContainerTypesErrors, ThrowOnError>({
    url: "/api/container-types",
    ...options,
  });

export const createContainerType = <ThrowOnError extends boolean = false>(
  options: Options<CreateContainerTypeData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateContainerTypeResponses, CreateContainerTypeErrors, ThrowOnError>({
    url: "/api/container-types",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const deleteContainerType = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContainerTypeData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteContainerTypeResponses, DeleteContainerTypeErrors, ThrowOnError>({
    url: "/api/container-types/{containerTypeId}",
    ...options,
  });

export const getContainerType = <ThrowOnError extends boolean = false>(
  options: Options<GetContainerTypeData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetContainerTypeResponses, GetContainerTypeErrors, ThrowOnError>({
    url: "/api/container-types/{containerTypeId}",
    ...options,
  });

export const updateContainerType = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContainerTypeData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateContainerTypeResponses, UpdateContainerTypeErrors, ThrowOnError>({
    url: "/api/container-types/{containerTypeId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getContainers = <ThrowOnError extends boolean = false>(
  options?: Options<GetContainersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetContainersResponses, GetContainersErrors, ThrowOnError>({
    url: "/api/containers",
    ...options,
  });

export const createContainer = <ThrowOnError extends boolean = false>(
  options: Options<CreateContainerData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateContainerResponses, CreateContainerErrors, ThrowOnError>({
    url: "/api/containers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const createContainers = <ThrowOnError extends boolean = false>(
  options: Options<CreateContainersData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateContainersResponses, CreateContainersErrors, ThrowOnError>({
    url: "/api/containers/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getContainerById = <ThrowOnError extends boolean = false>(
  options: Options<GetContainerByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetContainerByIdResponses, GetContainerByIdErrors, ThrowOnError>({
    url: "/api/containers/{containerId}",
    ...options,
  });

export const updateContainer = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContainerData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateContainerResponses, UpdateContainerErrors, ThrowOnError>({
    url: "/api/containers/{containerId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const addContentToContainer = <ThrowOnError extends boolean = false>(
  options: Options<AddContentToContainerData, ThrowOnError>,
) =>
  (options.client ?? client).post<AddContentToContainerResponses, AddContentToContainerErrors, ThrowOnError>({
    url: "/api/containers/{containerId}/content",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const deleteContentBatchWithoutCheck = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContentBatchWithoutCheckData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteContentBatchWithoutCheckResponses,
    DeleteContentBatchWithoutCheckErrors,
    ThrowOnError
  >({
    url: "/api/content",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const addContentToContainerBatch = <ThrowOnError extends boolean = false>(
  options: Options<AddContentToContainerBatchData, ThrowOnError>,
) =>
  (options.client ?? client).put<AddContentToContainerBatchResponses, AddContentToContainerBatchErrors, ThrowOnError>({
    url: "/api/content/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const changeContentLevelBatch = <ThrowOnError extends boolean = false>(
  options: Options<ChangeContentLevelBatchData, ThrowOnError>,
) =>
  (options.client ?? client).post<ChangeContentLevelBatchResponses, ChangeContentLevelBatchErrors, ThrowOnError>({
    url: "/api/content/level/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const listExternalSystemsSettings = <ThrowOnError extends boolean = false>(
  options?: Options<ListExternalSystemsSettingsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListExternalSystemsSettingsResponses,
    ListExternalSystemsSettingsErrors,
    ThrowOnError
  >({ url: "/api/external/settings/external-system", ...options });

export const storeExternalSystemSettings = <ThrowOnError extends boolean = false>(
  options: Options<StoreExternalSystemSettingsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StoreExternalSystemSettingsResponses,
    StoreExternalSystemSettingsErrors,
    ThrowOnError
  >({
    url: "/api/external/settings/external-system",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const triggerSync = <ThrowOnError extends boolean = false>(options?: Options<TriggerSyncData, ThrowOnError>) =>
  (options?.client ?? client).post<TriggerSyncResponses, TriggerSyncErrors, ThrowOnError>({
    url: "/api/external/settings/external-system/sync",
    ...options,
  });

export const deleteExternalSystemSettings = <ThrowOnError extends boolean = false>(
  options: Options<DeleteExternalSystemSettingsData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteExternalSystemSettingsResponses,
    DeleteExternalSystemSettingsErrors,
    ThrowOnError
  >({ url: "/api/external/settings/external-system/{id}", ...options });

export const updateExternalSystemSettings = <ThrowOnError extends boolean = false>(
  options: Options<UpdateExternalSystemSettingsData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateExternalSystemSettingsResponses,
    UpdateExternalSystemSettingsErrors,
    ThrowOnError
  >({
    url: "/api/external/settings/external-system/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>) =>
  (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({ url: "/api/iam/me", ...options });

export const startPasswordReset = <ThrowOnError extends boolean = false>(
  options: Options<StartPasswordResetData, ThrowOnError>,
) =>
  (options.client ?? client).post<StartPasswordResetResponses, StartPasswordResetErrors, ThrowOnError>({
    url: "/api/iam/password-reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const confirmPasswordReset = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmPasswordResetData, ThrowOnError>,
) =>
  (options.client ?? client).post<ConfirmPasswordResetResponses, ConfirmPasswordResetErrors, ThrowOnError>({
    url: "/api/iam/password-reset/confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const signIn = <ThrowOnError extends boolean = false>(options: Options<SignInData, ThrowOnError>) =>
  (options.client ?? client).post<SignInResponses, SignInErrors, ThrowOnError>({
    url: "/api/iam/sign-in",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const signOut = <ThrowOnError extends boolean = false>(options?: Options<SignOutData, ThrowOnError>) =>
  (options?.client ?? client).post<SignOutResponses, SignOutErrors, ThrowOnError>({
    url: "/api/iam/sign-out",
    ...options,
  });

export const signUp = <ThrowOnError extends boolean = false>(options: Options<SignUpData, ThrowOnError>) =>
  (options.client ?? client).post<SignUpResponses, SignUpErrors, ThrowOnError>({
    url: "/api/iam/sign-up",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const confirmSignUp = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmSignUpData, ThrowOnError>,
) =>
  (options.client ?? client).get<ConfirmSignUpResponses, ConfirmSignUpErrors, ThrowOnError>({
    url: "/api/iam/sign-up/confirm/{token}",
    ...options,
  });

export const getVersion = <ThrowOnError extends boolean = false>(options?: Options<GetVersionData, ThrowOnError>) =>
  (options?.client ?? client).get<GetVersionResponses, GetVersionErrors, ThrowOnError>({
    url: "/api/info/version",
    ...options,
  });

export const sendConfirmationMail = <ThrowOnError extends boolean = false>(
  options: Options<SendConfirmationMailData, ThrowOnError>,
) =>
  (options.client ?? client).post<SendConfirmationMailResponses, SendConfirmationMailErrors, ThrowOnError>({
    url: "/api/mail/confirmation",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getOrders = <ThrowOnError extends boolean = false>(options?: Options<GetOrdersData, ThrowOnError>) =>
  (options?.client ?? client).get<GetOrdersResponses, GetOrdersErrors, ThrowOnError>({
    url: "/api/orders",
    ...options,
  });

export const createOrder = <ThrowOnError extends boolean = false>(options: Options<CreateOrderData, ThrowOnError>) =>
  (options.client ?? client).post<CreateOrderResponses, CreateOrderErrors, ThrowOnError>({
    url: "/api/orders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const unscheduleDelivery = <ThrowOnError extends boolean = false>(
  options: Options<UnscheduleDeliveryData, ThrowOnError>,
) =>
  (options.client ?? client).delete<UnscheduleDeliveryResponses, UnscheduleDeliveryErrors, ThrowOnError>({
    url: "/api/orders/delivery-schedule",
    ...options,
  });

export const getDeliverySchedule = <ThrowOnError extends boolean = false>(
  options: Options<GetDeliveryScheduleData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetDeliveryScheduleResponses, GetDeliveryScheduleErrors, ThrowOnError>({
    url: "/api/orders/delivery-schedule",
    ...options,
  });

export const scheduleDelivery = <ThrowOnError extends boolean = false>(
  options: Options<ScheduleDeliveryData, ThrowOnError>,
) =>
  (options.client ?? client).put<ScheduleDeliveryResponses, ScheduleDeliveryErrors, ThrowOnError>({
    url: "/api/orders/delivery-schedule",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getOrder = <ThrowOnError extends boolean = false>(options: Options<GetOrderData, ThrowOnError>) =>
  (options.client ?? client).get<GetOrderResponses, GetOrderErrors, ThrowOnError>({
    url: "/api/orders/{orderNumber}",
    ...options,
  });

export const updateOrder = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderData, ThrowOnError>) =>
  (options.client ?? client).put<UpdateOrderResponses, UpdateOrderErrors, ThrowOnError>({
    url: "/api/orders/{orderNumber}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getPriceOverrides = <ThrowOnError extends boolean = false>(
  options?: Options<GetPriceOverridesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetPriceOverridesResponses, GetPriceOverridesErrors, ThrowOnError>({
    url: "/api/price-overrides",
    ...options,
  });

export const setPriceOverrides = <ThrowOnError extends boolean = false>(
  options: Options<SetPriceOverridesData, ThrowOnError>,
) =>
  (options.client ?? client).post<SetPriceOverridesResponses, SetPriceOverridesErrors, ThrowOnError>({
    url: "/api/price-overrides",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getPriceSettings = <ThrowOnError extends boolean = false>(
  options?: Options<GetPriceSettingsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetPriceSettingsResponses, GetPriceSettingsErrors, ThrowOnError>({
    url: "/api/price-settings",
    ...options,
  });

export const setPriceSettings = <ThrowOnError extends boolean = false>(
  options: Options<SetPriceSettingsData, ThrowOnError>,
) =>
  (options.client ?? client).post<SetPriceSettingsResponses, SetPriceSettingsErrors, ThrowOnError>({
    url: "/api/price-settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getPrices = <ThrowOnError extends boolean = false>(options?: Options<GetPricesData, ThrowOnError>) =>
  (options?.client ?? client).get<GetPricesResponses, GetPricesErrors, ThrowOnError>({
    url: "/api/prices",
    ...options,
  });

export const getCuttingLengths = <ThrowOnError extends boolean = false>(
  options?: Options<GetCuttingLengthsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCuttingLengthsResponses, GetCuttingLengthsErrors, ThrowOnError>({
    url: "/api/settings/cutting-lengths",
    ...options,
  });

export const getHumidityLevels = <ThrowOnError extends boolean = false>(
  options?: Options<GetHumidityLevelsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetHumidityLevelsResponses, GetHumidityLevelsErrors, ThrowOnError>({
    url: "/api/settings/humidity-levels",
    ...options,
  });

export const getWoodTypes = <ThrowOnError extends boolean = false>(options?: Options<GetWoodTypesData, ThrowOnError>) =>
  (options?.client ?? client).get<GetWoodTypesResponses, GetWoodTypesErrors, ThrowOnError>({
    url: "/api/settings/wood-types",
    ...options,
  });

export const getContainerStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetContainerStatisticsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetContainerStatisticsResponses, GetContainerStatisticsErrors, ThrowOnError>({
    url: "/api/statistics/containers",
    ...options,
  });

export const getContentLevelEventStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetContentLevelEventStatisticsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetContentLevelEventStatisticsResponses,
    GetContentLevelEventStatisticsErrors,
    ThrowOnError
  >({ url: "/api/statistics/content", ...options });
